import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter, createRoutesFromChildren, matchRoutes, useLocation, useNavigationType} from 'react-router-dom';
import 'nprogress/nprogress.css';
import * as Sentry from "@sentry/react";

const initSentry = () => {

    if (process.env?.REACT_APP_API_URL || window._env_.REACT_APP_API_URL) {
        Sentry.init({
            dsn: "https://5074e17d911af123e0702c02a151636f@o4505821163945984.ingest.us.sentry.io/4506490867810304",
            ignoreErrors: [
                // add strings here like:
                // "Network Error",
                // "timeout of 30000ms exceeded",
                // "Request aborted",
                // "Request failed with status code 429",
                "canceled",
                "CanceledError",
                // "Request failed with status code 401"
                // 'Request failed with status code 422'
                // 'e.focus is not a functions
            ],
            integrations: [
                Sentry.browserApiErrorsIntegration({
                    setTimeout: true,
                    setInterval: true,
                    requestAnimationFrame: true,
                    XMLHttpRequest: true,
                    eventTarget: true,
                }),
                Sentry.reactRouterV6BrowserTracingIntegration({
                    useEffect: React.useEffect,
                    useLocation,
                    useNavigationType,
                    createRoutesFromChildren,
                    matchRoutes,
                }),
                Sentry.breadcrumbsIntegration({
                    console: true,
                    dom: true,
                    fetch: true,
                    history: true,
                    xhr: true,
                }),
                Sentry.replayIntegration(),
                Sentry.captureConsoleIntegration({
                    levels: ["error"],
                }),
                Sentry.reportingObserverIntegration(),
                // Sentry.sessionTimingIntegration(),
            ],
            // debug: true, uncomment for debugging your application
            tracesSampleRate: 0.2, // Capture n% of the transactions
            sampleRate: 1.0,
            replaysSessionSampleRate: 0.1, // Sample rate at 10%
            replaysOnErrorSampleRate: 1.0, // 100% sample rate on errors
        });
    }
};

initSentry();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <>
        <BrowserRouter basename="/">
            <App/>
        </BrowserRouter>
    </>
);
//****** strict mode removed as it caused of extra render */

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
